// @flow
import * as materialAppearance from './material'
import type { Styles } from '..'

export const Label = (props: Styles) => {
  const styles = {
    ...materialAppearance.Label(props),
    transform: 'translate(0, 1.5px) scale(1)',
    fontWeight: 600,
    paddingLeft: '5px',
    color: '#444',
  }

  if (props.$nonEmpty) {
    styles.color = `${props.$palette('PRIMARY')}`
  }

  return styles
}

export const InputWrapper = (props: Styles) => {
  return {
    ...materialAppearance.InputWrapper(props),
    paddingLeft: '5px',
    marginTop: '24px',
  }
}
